import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@yara-dpp/frontend-components.ui.button';

import { useAppDispatch, useAppSelector } from '@/app/hooks';
import routes from '@/app/routes';
import { selectGlobalError, setGlobalError } from '@/app/coreSlice';

interface ErrorPageProps {
  errorStatusCode?: number;
}

const ErrorPage = ({ errorStatusCode }: ErrorPageProps) => {
  const [status, setStatus] = useState<number>(0);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const globalError = useAppSelector(selectGlobalError);

  useEffect(() => {
    if (errorStatusCode) {
      setStatus(errorStatusCode);
    }
  }, [errorStatusCode]);

  return (
    <section className="min-h-[calc(100vh_-_60px)] flex flex-col items-center justify-center bg-yara-background-primary py-12">
      <h2 className="text-2xl font-bold mb-6">
        An error occurred. Contact your IT department to get help.
      </h2>

      {status === 404 && (
        <>
          <p>The requested URL was not found on this server.</p>
        </>
      )}

      <div className="text-center">
        {globalError && (
          <>
            <p className="text-gray-700 text-lg font-bold mb-4">
              {globalError.message}
            </p>
            {globalError.status && (
              <p className="text-red-400 text-xl font-bold mb-4">
                Status code: {globalError.status}
              </p>
            )}
            <Button
              className="m-auto"
              onClick={() => {
                navigate(routes.LOGIN);
                dispatch(setGlobalError(null));
              }}
              type="action"
            >
              Go to login
            </Button>
          </>
        )}
      </div>
    </section>
  );
};

export default ErrorPage;
